import React from 'react'

interface PreviewBannerProps {
  height?: number | undefined
  width?: number | string | undefined
  backgroundColor: string
  textColor: string
  bannerText: string
  cartBannerFlags?: {
    isCartBottomBanner?: boolean
    isCartPreview?: boolean
    borderColor?: string
  }
}

const PreviewBanner: React.FC<PreviewBannerProps> = ({
  height = 32,
  width = '100%',
  backgroundColor,
  textColor,
  bannerText,
  cartBannerFlags = {
    isCartBottomBanner: false,
    isCartPreview: false,
    borderColor: '#FFFFFF'
  }
}) => {
  return (
    <div
      style={{
        background: backgroundColor,
        height: height,
        width: width,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: cartBannerFlags.isCartBottomBanner ? `1px solid ${cartBannerFlags.borderColor}` : 'none',
        borderBottom: !cartBannerFlags.isCartBottomBanner ? `1px solid ${cartBannerFlags.borderColor}` : 'none'
      }}
      className={`${
        cartBannerFlags.isCartPreview ? (cartBannerFlags.isCartBottomBanner ? 'rounded-t-xl' : 'rounded-b-xl') : ''
      }`}
    >
      <div
        dangerouslySetInnerHTML={{ __html: bannerText }}
        style={{ color: textColor, fontSize: 14, textAlign: 'center', margin: 0, lineHeight: '14px' }}
      ></div>
    </div>
  )
}

export default PreviewBanner
